import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Base from "../../base/views/base";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import MaterialTable from "material-table";
import MasterProductForm from "./MasterProductForm";
import Popup from "../../base/views/Popup";
import { getMasterProducts } from "../helper/masterProductHelper";
import PropTypes from "prop-types";
import { Tabs, Tab, Box } from "@material-ui/core";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      maxBodyHeight: "100%",
    },
  },
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    paddingTop: theme.spacing(2),
    borderRadius: "2px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  formControl: {
    margin: 0,
    fullWidth: true,
    display: "flex",
    wrap: "nowrap",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  border: {
    border: "2px solid red",
  },
  card: {
    width: "100%",
    marginBottom: "0.5rem",
    marginTop: "0.3rem",
  },
  cardBody: {
    padding: "2rem",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MasterProduct() {
  const classes = useStyles();
  const [viewData, setViewData] = React.useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pageNumber, setPageNumber] = useState();
  const [pageSize, setPageSize] = useState(100);
  const [search, setSearch] = useState("");
  let tableRef = React.createRef();
  const [isEdited, setIsEdited] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [value, setValue] = React.useState(0);
  const [
    showIndividualMasterProductData,
    setShowIndividualMasterProductData,
  ] = React.useState(false);

  const viewDataCells = [
    {
      id: 1,
      label: "Item Number",
      key: "application_number",
      category: "general",
    },
    { id: 2, label: "Description", key: "description", category: "general" },
    { id: 3, label: "NDC", key: "c_ndc", category: "general" },
    {
      id: 4,
      label: "Generic Description",
      key: "generic_description",
      category: "generic",
    },
    { id: 5, label: "Manufacturer Name", key: "mfr_name", category: "general" },
    { id: 6, label: "Drug schd", key: "drug_schd", category: "general" },
    { id: 7, label: "Strength", key: "strength", category: "general" },
    { id: 8, label: "Dosage Form", key: "dosage_form", category: "general" },
    { id: 9, label: "UPC", key: "upc", category: "general" },
    { id: 10, label: "Product Type", key: "product_type", category: "general" },
    { id: 11, label: "Generic Cd", key: "generic_cd", category: "generic" },
    {
      id: 12,
      label: "Generic Status",
      key: "generic_status",
      category: "generic",
    },
    {
      id: 13,
      label: "Generic Sequence Number",
      key: "generic_seq_no",
      category: "generic",
    },
    {
      id: 14,
      label: "Generic Sequence Number",
      key: "generic_seq_no",
      category: "generic",
    },
    {
      id: 15,
      label: "Package NDC",
      key: "package_ndc",
      category: "package_info",
    },
    {
      id: 16,
      label: "Level 1 Pack size",
      key: "level_1_pack_size",
      category: "package_info",
    },
    {
      id: 17,
      label: "Level 2 Pack size",
      key: "level_2_pack_size",
      category: "package_info",
    },
    {
      id: 18,
      label: "Level 3 Pack size",
      key: "level_3_pack_size",
      category: "package_info",
    },
    { id: 19, label: "Case Qty", key: "case_qty", category: "package_info" },
    {
      id: 20,
      label: "Storage Temperature",
      key: "storage_temp",
      category: "additional_info",
    },
    { id: 21, label: "Route", key: "route", category: "additional_info" },
    { id: 22, label: "Shape", key: "shape", category: "additional_info" },
    { id: 23, label: "Color", key: "color", category: "additional_info" },
    { id: 24, label: "Imprints", key: "imprints", category: "additional_info" },
    { id: 25, label: "UOM", key: "uom", category: "additional_info" },
    {
      id: 26,
      label: "Orange Book Code",
      key: "orange_code_book",
      category: "additional_info",
    },
    {
      id: 27,
      label: "Application Number",
      key: "application_number",
      category: "additional_info",
    },
    { id: 28, label: "Hazard", key: "hazard", category: "additional_info" },
  ];

  useEffect(() => {
    if (isEdited === true || isDeleted === true) {
      tableRef.current && tableRef.current.onQueryChange();
      setIsEdited(false);
      setIsDeleted(false);
    }
    // eslint-disable-next-line
  }, [isEdited, isDeleted]);

  const onEditButtonClick = (rowData) => {
    setSelectedItem(rowData);
    setOpenPopup(true);
  };
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const onPopupClose = (data) => {
    setOpenPopup(false);
  };

  const viewTabData = (categoryType) => {
    return (
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableBody>
            <TableRow></TableRow>
            {viewData &&
              viewDataCells.map(
                (cell, index) =>
                  cell.category === categoryType && (
                    <TableRow key={cell.id}>
                      <TableCell>
                        <b>{cell.label}</b>
                      </TableCell>
                      <TableCell>
                        {viewData[cell.key] ? viewData[cell.key] : ""}
                      </TableCell>
                    </TableRow>
                  )
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  return (
    <>
      <div style={{ display: "flex" }}>
        <Base
          showBaseMenu={true}
          hideHomeButton={true}
          hideDrawer={true}
          hidePharmacyButton={false}
          title="Master Products"
          showAppsIcon={true}
        >
          <div
            className={classes.root}
            width="xl"
            style={{ marginTop: "3.5%" }}
          >
            <MaterialTable
              tableRef={tableRef}
              title=""
              columns={[
                {
                  title: "Package NDC",
                  field: "package_ndc",
                  cellStyle: {
                    width: "15%",
                  },
                },
                {
                  title: "Description",
                  field: "description",
                  cellStyle: {
                    width: "35%",
                  },
                },
                {
                  title: "NDC",
                  field: "c_ndc",
                },
                {
                  title: "UPC",
                  field: "upc",
                },
                {
                  title: "Dosage Form",
                  field: "dosage_form",
                },
                {
                  title: "Product Type",
                  field: "product_type",
                },
              ]}
              data={(query) =>
                new Promise((resolve, reject) => {
                  setSearch(query.search);
                  setPageSize(query.pageSize);
                  const pagingObject = {
                    search: query.search,
                    page_number: query.page + 1,
                    page_size: query.pageSize,
                  };
                  setPageNumber(pagingObject.page_number);

                  getMasterProducts(pagingObject).then((response) => {
                    if (response.data.length > 0) {
                      resolve({
                        data: response.data,
                        page: query.page,
                        totalCount: Number(response.data[0].totalcount),
                      });
                    } else {
                      resolve({
                        data: [],
                        page: query.page,
                        totalCount: 0,
                      });
                    }
                  });
                })
              }
              actions={[
                {
                  icon: "edit",
                  tooltip: "Edit",
                  onClick: (event, rowData) => {
                    onEditButtonClick(rowData);
                  },
                },
              ]}
              options={{
                maxBodyHeight: 600,
                paging: true,
                search: true,
                pageSize: pageSize,
                pageSizeOptions: [50, 100, 250, 500],
              }}
              onRowClick={(event, rowData) => {
                setViewData(rowData);
                setShowIndividualMasterProductData(true);
              }}
            />
          </div>
          <LandingPageFooter />
          <Popup
            title="Master Product Form"
            openPopup={openPopup}
            isMasterProduct={true}
            setOpenPopup={setOpenPopup}
          >
            <MasterProductForm
              recordForEdit={selectedItem}
              onPopupClose={onPopupClose}
              pageNumber={pageNumber}
              pageSize={pageSize}
              setIsEdited={setIsEdited}
              search={search}
            />
          </Popup>
          <Popup
            title="Master Product"
            isMasterProduct={false}
            openPopup={showIndividualMasterProductData}
            setOpenPopup={setShowIndividualMasterProductData}
          >
            <Box sx={{ width: "700px" }}>
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{ borderBottom: 1, borderColor: "divider", width: "92%" }}
                >
                  <Tabs
                    value={value}
                    onChange={handleTabChange}
                    aria-label="basic tabs example"
                  >
                    <Tab label="Product Info" {...a11yProps(0)} />
                    <Tab label="Package Info" {...a11yProps(1)} />
                    <Tab label="Additional Info" {...a11yProps(2)} />
                  </Tabs>
                </Box>
                <Box sx={{ width: "8%" }}>
                  <IconButton
                    onClick={() => {
                      onEditButtonClick(viewData);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Box>
              </Box>

              <TabPanel value={value} index={0}>
                <Accordion defaultExpanded={false}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>General</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{viewTabData("general")}</Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded={false}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Generic</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{viewTabData("generic")}</Typography>
                  </AccordionDetails>
                </Accordion>
              </TabPanel>
              <TabPanel value={value} index={1}>
                {viewTabData("package_info")}
              </TabPanel>
              <TabPanel value={value} index={2}>
                {viewTabData("additional_info")}
              </TabPanel>
            </Box>
          </Popup>
        </Base>
      </div>
    </>
  );
}
